"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH_ACTIVE = 'workspace/SWITCH_ACTIVE/SUCCESS';
exports.CREATE_REQUEST = 'workspace/CREATE/REQUEST';
exports.CREATE_SUCCESS = 'workspace/CREATE/SUCCESS';
exports.CREATE_FAILURE = 'workspace/CREATE/FAILURE';
exports.UPDATE_REQUEST = 'workspace/UPDATE/REQUEST';
exports.UPDATE_SUCCESS = 'workspace/UPDATE/SUCCESS';
exports.UPDATE_FAILURE = 'workspace/UPDATE/FAILURE';
//# sourceMappingURL=types.js.map